import { useCallback } from 'react';
import axios, { useApiRequest } from './axios';
import { SubscriptionTariff } from '../types/subscriptions';
import { CommonListResponse } from '../types/crud';

const SUBSCRIPTION_TARIFFS_URL = '/payment/subscription-tariffs/';

export const useSubscriptionTariffsRequests = () => {
  const { loading, error, executeRequest } = useApiRequest();

    const query = useCallback(async (): Promise<CommonListResponse<SubscriptionTariff>> => {
    const { data } = await executeRequest(() => axios.get(SUBSCRIPTION_TARIFFS_URL));
    return data;
  }, [executeRequest]);

  return { loading, error, query };
};
